// BannerUploadModal.jsx
import React, { useEffect, useState } from 'react';
import BaseModal from '../baseModal';
import './style.scss';
import { useConnect } from '@stacks/connect-react';
import { authenticatedUserAddress, getUserData, network } from '../../services/auth';
import { clientNetwork, stacksApi, stacksExplorer, stacksExplorerParam } from '../../lib/constants';
import { AnchorMode, noneCV, optionalCVOf, stringUtf8CV } from '@stacks/transactions';
import axios from 'axios';

const appOrigin = window.location.origin;

const BannerUploadModal = ({
  show,
  close,
  currentMempool,
  txId,
  setTxId,
  storageUrl,
  userSettings,
}) => {
  const [storePath] = useState(getUserData()?.profile?.apps[appOrigin] === storageUrl);
  const { doContractCall } = useConnect();

  const authUser = authenticatedUserAddress({ network: clientNetwork });
  const userContractName = 'derupt-debug-profile';

  function redirect() {
    window.open(
      `${userSettings?.stacksExplorer || stacksExplorer}/txid/${txId}${stacksExplorerParam}`,
      '_blank'
    );
  }

  function setUpStoragePath() {
    const appStoragePath = getUserData().profile.apps[appOrigin]
      ? optionalCVOf(stringUtf8CV(getUserData().profile.apps[appOrigin]))
      : noneCV();
    doContractCall({
      contractAddress: authUser,
      contractName: userContractName,
      functionName: 'set-loadout-uri',
      functionArgs: [appStoragePath],
      network: network({ network: clientNetwork }),
      anchorMode: AnchorMode.OnChainOnly,
      stxAddress: authUser,
      onFinish: ({ txId: tx }) => {
        setTxId(tx);
      },
    });
  }

  useEffect(() => {
    currentMempool.forEach((res) => {
      if (res?.tx_type === 'contract_call') {
        const {
          tx_id,
          contract_call: { function_name },
        } = res;
        if (function_name === 'set-loadout-uri') {
          setTxId(tx_id);
        }
      }
    });
  }, [currentMempool, setTxId]);

  useEffect(() => {
    async function init() {
      if (txId) {
        const res = (await axios.get(`${stacksApi[clientNetwork]}/extended/v1/tx/${txId}`)).data;
        if (res?.contract_call) {
          const {
            tx_status,
            contract_call: { contract_id, function_name },
          } = res;
          if (
            contract_id === `${authUser}.${userContractName}` &&
            function_name === 'set-loadout-uri' &&
            tx_status === 'pending'
          ) {
            return;
          }
        }
        setTxId('');
      }
    }
    init();
  }, [txId, authUser]);

  return (
    <BaseModal show={show} handleClose={close} title="">
      <div className="list-box">
        <p id="bns-warning">Requirement Error</p>
        <div className="list-container">
          <ul id="bnsul">
            <li>
              ℹ️ Before you can customize your banner, you first need to set up your loadout. After
              you set up or update your loadout, you can customize your banner.
            </li>
            {txId ? (
              <li>
                ⏳ Loadout Change Pending{' '}
                <button onClick={redirect}>
                  {txId.substring(0, 5) + ' ... ' + txId.substring(txId.length - 5)}
                </button>
              </li>
            ) : null}
          </ul>
        </div>
        {!storePath && !txId && (
          <button className="button" onClick={setUpStoragePath}>
            {' '}
            Setup Loadout{' '}
          </button>
        )}
        {storePath && !txId && (
          <button className="button" onClick={setUpStoragePath}>
            {' '}
            Update Loadout{' '}
          </button>
        )}
      </div>
    </BaseModal>
  );
};

export default BannerUploadModal;
